export const language = {
    zh: {
      '充电中': '充电中',
      '充满电': '充满电',
      '请使用2.4G模式或者有线模式连接设备': '请使用2.4G模式或者有线模式连接设备',
      '鼠标左键锁': '鼠标左键锁',
      '已设置宏按键': '已设置宏按键',
      '当前固件为最新版本，无需升级': '当前固件为最新版本，无需升级',
      '当前接收器为最新版本,无需升级': '当前接收器为最新版本,无需升级',
      '左键配置已经锁定,无法配置': '左键配置已经锁定,无法配置',
      'DPI调节': 'DPI调节',
      '该操作会删除所有已保存的数据，是否继续？': '该操作会删除所有已保存的数据，是否继续？',
      '连接新设备': '连接新设备',
      '想要连接到HID设备': '想要连接到HID设备',
      '官网': '官网',
      '配置': '配置',
      '恢复出厂设置': '恢复出厂设置',
      '运行状态': '运行状态',
      '当前状态': '当前状态',
      '移动唤醒': '移动唤醒',
      '按键功能': '按键功能',
      'DPI': 'DPI',
      '回报率': '回报率',
      '宏定义': '宏定义',
      '性能设置': '性能设置',
      '固件': '固件',
      'LOD': 'LOD',
      '电量': '电量',
      '版本': '版本',
      '鼠标固件版本': '鼠标固件版本',
      '接收器固件版本': '接收器固件版本',
      '是否重置当前所有按键设置': '是否重置当前所有按键设置',
      '是': '是',
      '否': '否',
      '按键1 左键': '按键1 左键',
      '按键2 右键': '按键2 右键',
      '按键3 中键': '按键3 中键',
      '按键4 前进': '按键4 前进',
      '按键5 后退': '按键5 后退',
      '滚轮上 向上滚动': '滚轮上 向上滚动',
      '滚轮下 向下滚动': '滚轮下 向下滚动',
      '基础鼠标功能': '基础鼠标功能',
      '左键': '左键',
      '右键': '右键',
      '中键': '中键',
      '前进': '前进',
      '后退': '后退',
      '左键双击': '左键双击',
      '向上滚动': '向上滚动',
      '向下滚动': '向下滚动',
      '向左滚动': '向左滚动',
      '向右滚动': '向右滚动',
      '灵敏度': '灵敏度',
      'DPI Loop': 'DPI Loop',
      'DPI+': 'DPI+',
      'DPI-': 'DPI-',
      '多媒体按键': '多媒体按键',
      '音量+': '音量+',
      '音量-': '音量-',
      '静音': '静音',
      '播放器': '播放器',
      '播放/暂停': '播放/暂停',
      '上一首': '上一首',
      '下一首': '下一首',
      '停止播放': '停止播放',
      '系统快捷键': '系统快捷键',
      '屏幕亮度+': '屏幕亮度+',
      '屏幕亮度-': '屏幕亮度-',
      '启动计算器': '启动计算器',
      '我的电脑': '我的电脑',
      '打开主页': '打开主页',
      '邮件': '邮件',
      '刷新': '刷新',
      '切换应用': '切换应用',
      '复制': '复制',
      '剪切': '剪切',
      '粘粘': '粘粘',
      '宏按键': '宏按键',
      '请选择': '请选择',
      '键盘组合键': '键盘组合键',
      '设置': '设置',
      '请输入单键': '请输入单键',
      '保存': '保存',
      '游戏增强按键': '游戏增强按键',
      '每秒自动击键的次数': '每秒自动击键的次数',
      '设置': '设置',
      '鼠标按键': '鼠标按键',
      '键盘按键': '键盘按键',
      '键值': '键值',
      '次数': '次数',
      '速率': '速率',
      '禁用按键': '禁用按键',
      '设置成功': '设置成功',
      '确定': '确定',
      '是否重置DPI为默认值': '是否重置DPI为默认值',
      '第1档': '第1档',
      '第2档': '第2档',
      '第3档': '第3档',
      '第4档': '第4档',
      '第5档': '第5档',
      '固定数值': '固定数值',
      '指针设置': '指针设置',
      '目前数值': '目前数值',
      '确认设置': '确认设置',
      '调整设备向电脑回送报告的频率': '调整设备向电脑回送报告的频率',
      'LOD高度': 'LOD高度',
      '鼠标离开桌面停止运动的距离，低：1mm，高：2mm': '鼠标离开桌面停止运动的距离，低：1mm，高：2mm',
      '宏': '宏',
      '开始录制': '开始录制',
      '暂停录制': '暂停录制',
      '请新建宏后开始录制': '请新建宏后开始录制',
      '宏名称': '宏名称',
      '新建': '新建',
      '导入': '导入',
      '导出': '导出',
      '事件列表': '事件列表',
      '序号': '序号',
      '值': '值',
      '插入': '插入',
      '删除': '删除',
      '延时设置': '延时设置',
      '没有延时': '没有延时',
      '录制延时': '录制延时',
      '统一延时': '统一延时',
      '循环设置': '循环设置',
      '循环直到按键松开': '循环直到按键松开',
      '循环直到任意按键按下': '循环直到任意按键按下',
      '循环直到触发再按下': '循环直到触发再按下',
      '循环次数': '循环次数',
      '性能设置': '性能设置',
      'Sensor画线性能': 'Sensor画线性能',
      '波纹控制': '波纹控制',
      '直线修正': '直线修正',
      'Motion Sync开启': 'Motion Sync开启',
      '滚动方向设置': '滚动方向设置',
      '正向': '正向',
      '反向': '反向',
      '高速模式': '高速模式',
      '注：有利于提高性能，但会增加功耗，无法和2K/4K/8K同时开启': '注：有利于提高性能，但会增加功耗，无法和2K/4K/8K同时开启',
      '按键延迟响应（毫秒）': '按键延迟响应（毫秒）',
      '唤醒方式': '唤醒方式',
      '移动唤醒': '移动唤醒',
      '按键唤醒': '按键唤醒',
      '休眠时间': '休眠时间',
      '下载': '下载',
      '请新建宏后开始录制': '请新建宏后开始录制',
      '移动唤醒': '移动唤醒',
      '按键唤醒': '按键唤醒',
      '移动唤醒 按键唤醒': '移动唤醒 按键唤醒',
      '滚动方向': '滚动方向',
      '正向': '正向',
      '反向': '反向',
      '名称': '名称',
      '1分钟': '1分钟',
      '2分钟': '2分钟',
      '3分钟': '3分钟',
      '5分钟': '5分钟',
      '10分钟': '10分钟',
      '20分钟': '20分钟',
      '30分钟': '30分钟',
      '确认': '确认',
      '取消': '取消',
      '是否确认删除宏': '是否确认删除宏',
      '第1档': '第1档',
      '第2档': '第2档',
      '第3档': '第3档',
      '第4档': '第4档',
      '第5档': '第5档',
      '没有数据': '没有数据',
      '按键已禁用': '按键已禁用',
      
      '请连接设备': '请连接设备',
      '请唤醒鼠标,且确保鼠标处于2.4G模式': '请唤醒鼠标,且确保鼠标处于2.4G模式',
      '已设置游戏增强按键': '已设置游戏增强按键',
      '已设置禁用按键': '已设置禁用按键',
      '旋转': '旋转',
      '根据抓握方式调整鼠标传感器角度,即使在鼠标倾斜时也能实现精确的水平移动': '根据抓握方式调整鼠标传感器角度,即使在鼠标倾斜时也能实现精确的水平移动'
    },
    en: {
      '请使用2.4G模式或者有线模式连接设备': 'Please use 2.4G mode or wired mode to connect the device',
      '鼠标左键锁': 'Left Mouse Button Lock',
      '已设置宏按键': 'Macro keys have been set.',
      '当前固件为最新版本，无需升级': 'The current firmware is up to date, no upgrade is needed. ',
      '当前接收器为最新版本,无需升级': 'The current receiver is up to date, no upgrade is needed.',
      '左键配置已经锁定,无法配置': 'The left button configuration is locked and cannot be modified.',
      'DPI调节': 'DPI adjustment',
      '连接新设备': 'Connect New Device',
      '想要连接到HID设备': 'Connect to HID Device',
      '官网': 'Official Website',
      '配置': 'Configuration',
      '恢复出厂设置': 'Restore Factory Settings',
      '运行状态': 'Operating Status',
      
      '移动唤醒': 'Move to Wake',
      '按键功能': 'Button Functions',
      'DPI': 'DPI',
      '回报率': 'Polling Rate',
      '宏定义': 'Macro Definition',
      '性能设置': 'Performance Settings',
      '固件': 'Firmware',
      '当前状态': 'Current Status',
      'LOD': 'LOD',
      '电量': 'Battery',
      '版本': 'Version',
      '鼠标固件版本': 'Mouse Firmware Version',
      '接收器固件版本': 'Receiver Firmware Version',
      '是否重置当前所有按键设置': 'Please Enter Single Key',
      '是': 'Yes',
      '否': 'No',
      '按键1 左键': 'Button 1',
      '按键2 右键': 'Button 2',
      '按键3 中键': 'Button 3',
      '按键4 前进': 'Button 4',
      '按键5 后退': 'Button 5',
      '滚轮上 向上滚动': 'Scroll Up',
      '滚轮下 向下滚动': 'Scroll Down',
      '基础鼠标功能': 'Basic Mouse Button Functions',
      '左键': 'Left Click',
      '右键': 'Right Click',
      '中键': 'Middle Click',
      '前进': 'Forward',
      '后退': 'Backward',
      '左键双击': 'Left Double Click',
      '向上滚动': 'Scroll Up',
      '向下滚动': 'Scroll Down',
      '向左滚动': 'Scroll Left',
      '向右滚动': 'Scroll Right',
      '灵敏度': 'Sensitivity',
      'DPI Loop': 'DPI Loop',
      'DPI+': 'DPI+',
      'DPI-': 'DPI-',
      '多媒体按键': 'Media Control Keys',
      '音量+': 'Volume Up',
      '音量-': 'Volume Down',
      '静音': 'Mute',
      '播放器': 'Player',
      '播放/暂停': 'Play/Pause',
      '上一首': 'Previous Track',
      '下一首': 'Next Track',
      '停止播放': 'Stop Playing',
      '系统快捷键': 'System Shortcuts',
      '屏幕亮度+': 'Screen Brightness Up',
      '屏幕亮度-': 'Screen Brightness Down',
      '启动计算器': 'Open Calculator',
      '我的电脑': 'My Computer',
      '打开主页': 'Open Home Page',
      '邮件': 'Email',
      '刷新': 'Refresh',
      '切换应用': 'Switch Application',
      '复制': 'Copy',
      '剪切': 'Cut',
      '粘粘': 'Paste',
      '宏按键': 'Macro',
      '请选择': 'Please Select',
      '键盘组合键': 'Keyboard Combination Keys',
      '设置': 'Set',
      '请输入单键': 'Please Enter Single Key',
      '保存': 'Save',
      '游戏增强按键': 'Game Enhancement Keys',
      '每秒自动击键的次数': 'Auto Click Rate per Second',
      '设置': 'Set',
      '鼠标按键': 'Mouse Button',
      '键盘按键': 'Keyboard Key',
      '键值': 'key assignments',
      '次数': 'Clicks',
      '速率': 'Rate',
      '禁用按键': 'Disable Keys',
      '设置成功': 'Setting Successful',
      '确定': 'Confirm',
      '是否重置DPI为默认值': 'Reset DPI to Default?',
      '第1档': 'Level 1',
      '第2档': 'Level 2',
      '第3档': 'Level 3',
      '第4档': 'Level 4',
      '第5档': 'Level 5',
      '固定数值': 'Fixed Values',
      '指针设置': 'Pointer Settings',
      '目前数值': 'Current Value',
      '确认设置': 'Confirm Settings',
      '调整设备向电脑回送报告的频率': 'Adjust the Frequency of Data Sent to the Computer',
      'LOD高度': 'LOD Height',
      '鼠标离开桌面停止运动的距离，低：1mm，高：2mm': 'Distance at which the Mouse Stops Moving When Lifted Off the Surface, Low: 1mm, High: 2mm',
      '宏': 'Macro',
      '开始录制': 'Start Recording',
      '请新建宏后开始录制': 'Please Create a New Macro Before Starting Recording',
      '宏名称': 'Macro Name',
      '新建': 'New',
      '导入': 'Import',
      '导出': 'Export',
      '事件列表': 'Event List',
      '序号': 'Number',
      '值': 'Value',
      '插入': 'Insert',
      '删除': 'Delete',
      '延时设置': 'Delay Settings',
      '没有延时': 'No Delay',
      '录制延时': 'Record Delay',
      '统一延时': 'Uniform Delay',
      '循环设置': 'Loop Settings',
      '循环直到按键松开': 'Loop Until Button is Released',
      '循环直到任意按键按下': 'Loop Until Any Button is Pressed',
      '循环直到触发再按下': 'Loop Until Triggered Again',
      '循环次数': 'Number of Loops',
      '性能设置': 'Performance Settings',
      'Sensor画线性能': 'Sensor Drawing Performance',
      '波纹控制': 'Ripple Control',
      '直线修正': 'Straight Line Correction',
      'Motion Sync开启': 'Motion Sync On',
      '滚动方向设置': 'Scroll Direction Settings',
      '正向': 'Forward',
      '反向': 'Reverse',
      '高速模式': 'High-Speed Mode',
      '注：有利于提高性能，但会增加功耗，无法和2K/4K/8K同时开启': 'Note: Improves Performance but Increases Power Consumption, Cannot be Enabled with 2K/4K/8K Simultaneously',
      '按键延迟响应（毫秒）': 'Button Response Delay(Milliseconds)',
      '唤醒方式': 'Wake Method',
      '移动唤醒': 'Move to Wake',
      '按键唤醒': 'Button to Wake',
      '休眠时间': 'Sleep Time',
      '下载': 'Download',
      '暂停录制': 'Stop Recording',
      '请新建宏后开始录制': 'Please Create a New Macro Before Starting Recording',
      '移动唤醒': 'Move to Wake',
      '按键唤醒': 'Button to Wake',
      '移动唤醒 按键唤醒': 'Move to Wake Button to Wake',
      '滚动方向': 'Scroll Direction',
      '正向': 'Forward',
      '反向': 'Reverse',
      '名称': 'Name',
      '1分钟': '1min',
      '2分钟': '2mins',
      '3分钟': '3mins',
      '5分钟': '5mins',
      '10分钟': '10mins',
      '20分钟': '20mins',
      '30分钟': '30mins',
      '确认': 'Confirm',
      '取消': 'Cancel',
      '该操作会删除所有已保存的数据，是否继续？': 'This operation will delete all saved data. Do you want to continue?',
      '是否确认删除宏': 'Whether to delete the macro',
      '第1档': 'Level 1',
      '第2档': 'Level 2',
      '第3档': 'Level 3',
      '第4档': 'Level 4',
      '第5档': 'Level 5',
      '没有数据': 'No data',
      '请连接设备': 'Please connect the device',
      '请唤醒鼠标,且确保鼠标处于2.4G模式': 'Wake up the mouse and make sure the mouse is in 2.4G mode',
      '已设置游戏增强按键': 'The game enhancement button is set',
      '已设置禁用按键': 'The Disable button has been set',
      '旋转': 'rotation',
      '根据抓握方式调整鼠标传感器角度,即使在鼠标倾斜时也能实现精确的水平移动': 'Adjust the mouse sensor angle according to the grip style to achieve precise horizontal movement even when the mouse is tilted.'
    },
    jp: {
      '请使用2.4G模式或者有线模式连接设备': '2.4 Gモードまたは有線モードで機器を接続してください',
      '鼠标左键锁': '左ボタン機能ロック',
      '已设置宏按键': 'マクロボタンを割り当てました',
      '当前固件为最新版本，无需升级': '現在のファームウェアは既に最新版です。',
      '当前接收器为最新版本,无需升级': '現在のレシーバーは既に最新版です。',
      '左键配置已经锁定,无法配置': '左ボタンがロックされました、ほかの機能を割り当てることができません',
      '请连接设备': '設備を接続してください。',
      '请唤醒鼠标,且确保鼠标处于2.4G模式': '接続成功、現在は2.4Ghz接続状態です。',
      '已设置游戏增强按键': '連打ボタンが反映されました。',
      '已设置禁用按键': 'ボタンが禁止されました。',
      'DPI调节': 'DPI調整です',
      '连接新设备': '新しい設備に接続',
      '官网': '公式サイト',
      '想要连接到HID设备': 'File:///がHIDデバイスへの接続を求めています',
      '配置': 'プロフィール',
      '恢复出厂设置': '設定を初期化する',
      '运行状态': '本体設定',
      '移动唤醒': 'マウス移動',
      '按键功能': 'ボタン割り当て',
      'DPI': 'DPI',
      '回报率': 'ポーリングレート',
      '宏定义': 'マクロ定義',
      '性能设置': '性能設定',
      '固件': 'ファームウェア',
      '当前状态': '現在設定',
      'LOD': 'リフトオフディスタンス',
      '电量': 'バッテリー',
      '版本': 'バージョン',
      '鼠标固件版本': 'マウスファームウェアバージョン',
      '接收器固件版本': 'ドングルファームウェアバージョン',
      '是否重置当前所有按键设置': 'ボタン設定をデフォルト設定に戻しますか？',
      '是': 'はい',
      '否': 'いいえ',
      '按键1 左键': 'ボタン①左クリック',
      '按键2 右键': 'ボタン②右クリック',
      '按键3 中键': 'ボタン③ミドルクリック',
      '按键4 前进': 'ボタン④前進',
      '按键5 后退': 'ボタン⑤後退',
      '滚轮上 向上滚动': '上にスクロール',
      '滚轮下 向下滚动': '下にスクロール',
      '基础鼠标功能': 'マウスボタン機能',
      '左键': '左クリック',
      '右键': '右クリック',
      '中键': 'ミドルクリック',
      '前进': '前進',
      '后退': '後退',
      '左键双击': '左ダブルクリック',
      '向上滚动': '上にスクロール',
      '向下滚动': '下にスクロール',
      '向左滚动': '左にスクロール',
      '向右滚动': '右にスクロール',
      '灵敏度': 'DPI',
      'DPI Loop': 'DPIループ',
      'DPI+': 'DPI+',
      'DPI-': 'DPI-',
      '多媒体按键': 'マルチメディア機能',
      '音量+': '音量+',
      '音量-': '音量-',
      '静音': 'ミュート',
      '播放器': 'メディアプレイヤー',
      '播放/暂停': '再生/一時停止',
      '上一首': '前の曲',
      '下一首': '次の曲',
      '停止播放': 'ストップ',
      '系统快捷键': 'ショートカット',
      '屏幕亮度+': '画面明るさ+',
      '屏幕亮度-': '画面明るさ-',
      '启动计算器': '電卓を起動',
      '我的电脑': 'マイコンピュータ',
      '打开主页': 'ホームページを開く',
      '邮件': 'メール',
      '刷新': '最新の情報に更新',
      '切换应用': 'アプリを切り替える',
      '复制': 'コピー',
      '剪切': '切り取り',
      '粘粘': '貼り付け',
      '宏按键': 'マクロボタン',
      '请选择': '選択してください',
      '键盘组合键': 'キーボードファンクション',
      '设置': '設定',
      '请输入单键': '単一キーを入力してください',
      '保存': 'セーブ',
      '游戏增强按键': '連打ボタン',
      '每秒自动击键的次数': '秒ごとに自動的連打の回数',
      '设置': '設定',
      '鼠标按键': 'マウスボタン',
      '键盘按键': 'キーボードボタン',
      '键值': 'キー値です',
      '次数': '回数',
      '速率': '速度',
      '禁用按键': 'ボタン機能を禁止',
      '设置成功': '設定保存成功',
      '确定': 'はい',
      '是否重置DPI为默认值': 'DPI設定をデフォルト設定に戻しますか？',
      '第1档': '第1層',
      '第2档': '第2層',
      '第3档': '第3層',
      '第4档': '第4層',
      '第5档': '第5層',
      '固定数值': '固定値',
      '指针设置': 'カーソル設定',
      '目前数值': '現在値',
      '确认设置': '設定確定',
      '调整设备向电脑回送报告的频率': 'デバイスに送信されるマウスデータ頻度を調整',
      'LOD高度': 'リフトオフディスタンス高さ調整',
      '鼠标离开桌面停止运动的距离，低：1mm，高：2mm': 'マウスの持ち上げる時に動作停止の高さの調整 低:1mm；高：2mm',
      '宏': 'マクロ',
      '开始录制': '記録を開始',
      '请新建宏后开始录制': 'マクロを新規作成して記録を開始してください',
      '宏名称': 'マクロ',
      '新建': '新規作成',
      '导入': 'インポート',
      '导出': 'エクスポート',
      '事件列表': 'マクロリスト',
      '序号': '順番',
      '值': '値',
      '插入': 'エクスポート',
      '删除': '削除',
      '延时设置': '入力遅延設定',
      '没有延时': '遅延なし',
      '录制延时': '遅延を記録',
      '统一延时': '遅延設定を一致化',
      '循环设置': 'ループ設定',
      '循环直到按键松开': 'ボタンを離すまでループし続ける',
      '循环直到任意按键按下': '任意ボダンを押すまでにループし続ける',
      '循环直到触发再按下': '同一ボダンを再度押すまでにループし続ける',
      '循环次数': 'ループ回数',
      '性能设置': '性能設定',
      'Sensor画线性能': 'アングルスナップ',
      '波纹控制': 'リップル制御',
      '直线修正': '直線補正',
      'Motion Sync开启': 'Motion Sync On',
      '滚动方向设置': 'スクロール方向設定',
      '正向': '通常',
      '反向': '逆',
      '高速模式': '高速ゲーミングモード',
      '注：有利于提高性能，但会增加功耗，无法和2K/4K/8K同时开启': '注記:当モードを起動するとマウスの性能は最大化発揮できますが、バッテリーの消耗も激しくなります。（2K/4K/8Kの高ポーリングレートモード（既に高速化しているため）と同時にオンすることができません）',
      '按键延迟响应（毫秒）': 'デバウンス遅延設定（ms）*4msおすすめ',
      '唤醒方式': 'スリープ状態時ウェイクアップ方法',
      '移动唤醒': 'マウス移動',
      '按键唤醒': 'ボタン',
      '休眠时间': 'スリープ時間設定',
      '下载': 'ダウンロード',
      '暂停录制': '記録の停止',
      '请新建宏后开始录制': 'マクロを新規作成して記録を開始してください',
      '移动唤醒': 'マウス移動',
      '按键唤醒': 'ボタン',
      '移动唤醒 按键唤醒': 'マウス移動 ボタン',
      '滚动方向': 'スクロール方向',
      '正向': '通常',
      '反向': '逆',
      '名称': 'ネーム',
      '1分钟': '1分',
      '2分钟': '2分',
      '3分钟': '3分',
      '5分钟': '5分',
      '10分钟': '10分',
      '20分钟': '20分',
      '30分钟': '30分',
      '确认': '設定',
      '取消': '取り消します',
      '该操作会删除所有已保存的数据，是否继续？': '保存されている全てのデータを削除します。続けますか?',
      '是否确认删除宏': 'マクロファイルを削除するでよろしいですか? ',
      '第1档': '第1層',
      '第2档': '第2層',
      '第3档': '第3層',
      '第4档': '第4層',
      '第5档': '第5層',
      '没有数据': 'データがありません',
      '按键已禁用': 'キーが無効になっています',
      '旋转': '回転 します',
      '根据抓握方式调整鼠标传感器角度,即使在鼠标倾斜时也能实现精确的水平移动': 'どんな掴み方法、角度でもマウス移動を正確且つ水平的なスワイプに調整。'
    },
    kr: {},
  };
  